// Cache selectors and attach a single event listener to each accordion container
document.querySelectorAll('.accordion').forEach((accordion) => {
  const isExclusive = accordion.classList.contains('accordion--exclusive')

  accordion.addEventListener('click', (event) => {
    const btn = event.target.closest('.accordion-button')

    if (!btn) return // If the click is not on a button, do nothing

    const panel = btn.nextElementSibling
    const isPanelOpen = btn.classList.contains('is-active')

    if (isPanelOpen) {
      closePanel(btn, panel)
      return
    }

    if (isExclusive) {
      closeAllPanels(accordion)
    }

    openPanel(btn, panel)
  })
})

// Close all panels within a specific accordion
function closeAllPanels(accordion) {
  accordion.querySelectorAll('.accordion-button.is-active').forEach((btn) => {
    const panel = btn.nextElementSibling
    closePanel(btn, panel)
  })
}

// Close a specific panel
function closePanel(button, panel) {
  button.classList.remove('is-active')
  button.setAttribute('aria-expanded', 'false')
  if (panel) {
    panel.classList.remove('is-open')
    // panel.style.maxHeight = null // removed to allow block animation
  }
}

// Open a specific panel
function openPanel(button, panel) {
  button.classList.add('is-active')
  button.setAttribute('aria-expanded', 'true')
  if (panel) {
    panel.classList.add('is-open')
    // panel.style.maxHeight = panel.scrollHeight + 'px' // removed to allow block animation

    //== scroll to the top of the panel (if needed)
    // setTimeout(() => {
    //   button.scrollIntoView({
    //     behavior: 'smooth',
    //     block: 'start'
    //   })
    // }, 1000)
  }
}
